// Author-time tag picker for the dashboard editor.
//
// This button opens the shared graph-backed TagPicker and inserts the picked
// graph node ID at the Monaco cursor. Custom paths are intentionally disabled.

import { useState } from 'react'

import { TagPicker } from '../../../components/tags/TagPicker'

export interface InsertTagButtonProps {
  onInsert: (nodeId: string) => void
  disabled?: boolean
}

const InsertTagButton = ({ onInsert, disabled }: InsertTagButtonProps) => {
  // The picker's value is transient: each pick inserts and resets, so the
  // trigger reads "Insert registered tag…" rather than accumulating selections.
  const [picked] = useState<string[]>([])

  return (
    <div className="w-56" data-testid="dashboard-insert-tag" aria-disabled={disabled}>
      <TagPicker
        value={picked}
        // Paths are unused here — dashboard inserts go through onPick (node ID).
        onChange={() => undefined}
        onPick={onInsert}
        closeOnSelect
        disabled={disabled}
        placeholder="Insert registered tag…"
        idPrefix="dashboard-tag-picker"
      />
    </div>
  )
}

export default InsertTagButton
